import axios from 'axios';
import { handleErrorResponse } from '../util/handleErrorResponse';

const INSTANCE_PATH = '/comExec/api/index.php?api_path=';
const REALESTATE_PATH = '/realestate/provider';
const acceptHeader = { accept: 'application/json' };
const axiosInstance = axios.create({
  baseURL: INSTANCE_PATH,
  headers: acceptHeader,
});

export const realEstate = {
  getAptInfo: async () => {
    try {
      const res = await axiosInstance.get(`/apt/boot?host=${window.location.host}`);
      return res.data;
    } catch (err) {
      handleErrorResponse(err);
    }
  },

  getData: async (apt_id) => {
    try {
      const res = await axiosInstance.get(`${REALESTATE_PATH}?apt_id=${apt_id}`);
      return res.data;
    } catch (err) {
      handleErrorResponse(err);
    }
  },

  registerData: async (formData) => {
    const headers = { 'Content-Type': 'multipart/form-data' };
    try {
      const res = await axiosInstance.post(REALESTATE_PATH, formData, {
        headers,
      });
      return res.data;
    } catch (err) {
      handleErrorResponse(err);
    }
  },

  modifyData: async (formData, id) => {
    try {
      const res = await axiosInstance.post(`${REALESTATE_PATH}/${id}`, formData);
      return res.data;
    } catch (err) {
      handleErrorResponse(err);
    }
  },

  removeData: async (id) => {
    try {
      const res = await axiosInstance.delete(`${REALESTATE_PATH}/${id}`);
      return res.data;
    } catch (err) {
      handleErrorResponse(err);
    }
  },

  getProviderBoardData: async () => {
    try {
      const res = await axiosInstance.get(`/site/providerboard?board=520`);
      return res.data;
    } catch (err) {
      handleErrorResponse(err);
    }
  },
};
